import React from 'react';

export default function Logo({ className = 'h-10', showText = true, light = false }) {
  const primaryColor = light ? 'text-white' : 'text-blue-900';
  const secondaryColor = light ? 'text-blue-200' : 'text-blue-600';
  const textColor = light ? 'text-white' : 'text-slate-900';

  return (
    <div className={`flex items-center gap-3 select-none ${className}`}>
      {/* Logo Ikon */}
      <svg
        viewBox="0 0 100 100"
        className="h-full w-auto fill-none stroke-current"
        style={{ minWidth: '40px' }}
      >
        {/* Tag over logoet (Ydre tagkonstruktion) */}
        <path
          d="M5 45 L50 10 L95 45"
          strokeWidth="7"
          strokeLinecap="round"
          strokeLinejoin="round"
          className={secondaryColor}
        />
        {/* Indre tagkonstruktion */}
        <path
          d="M18 55 L50 27 L82 55"
          strokeWidth="5"
          strokeLinecap="round"
          strokeLinejoin="round"
          className={primaryColor}
        />
        {/* Understøttende bjælke (Tømrerarbejde) */}
        <path
          d="M25 65 L75 65"
          strokeWidth="5"
          strokeLinecap="round"
          strokeLinejoin="round"
          className={primaryColor}
        />
        {/* Lodret stolpe / Håndværks-søjle */}
        <path
          d="M50 27 L50 80"
          strokeWidth="5"
          strokeLinecap="round"
          strokeLinejoin="round"
          className={primaryColor}
        />
        {/* Fundament / Solid bund */}
        <path
          d="M35 80 L65 80"
          strokeWidth="7"
          strokeLinecap="round"
          strokeLinejoin="round"
          className={secondaryColor}
        />
      </svg>

      {/* Logo Tekst */}
      {showText && (
        <div className="flex flex-col leading-none">
          <span className={`font-sans font-extrabold text-xl tracking-wide ${textColor}`}>
            TOA BYG
          </span>
          <span className={`font-sans font-semibold text-xs tracking-[0.2em] uppercase ${light ? 'text-white' : 'text-black'}`}>
            ApS
          </span>
        </div>
      )}
    </div>
  );
}
